<template>
  <div class="app-main-inner-row input-dialog">
    <el-form style="width:100%;height: 800px" label-position="right" label-width="120px">
      <el-row>
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="titleGrid.gridOptions"
          :column-defs="titleGrid.titleColumnDefs"
          :row-data="titleGrid.rowData"
          style="width:700px;height:200px;padding-bottom: 5px"
          @gridReady="params=>titleGrid.gridApi=params.api"
        />
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="$t('CargoMsg.Cargo_ReceiptInvoiceChannel')" required>
          <el-select v-model="from.inputTaxInvoiceChannel" no="inputTaxInvoiceChannel" :disabled="!isEdit" style="width:300px;" @change="invoiceChannelChange">
            <el-option
              v-for="item in SystemConstants.INVOICE_CHANNEL_STATUS"
              :key="item.code"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <!--诺诺网全电发票:NUONUO-->
        <div v-if="isNuoNuo">
          <el-form-item :label="'APPkey'" required>
            <el-input v-model="from.inputTaxAppKey" no="inputTaxAppKey" :disabled="!isEdit" class="input-color" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="'APPSecret'" required>
            <el-input v-model="from.inputTaxAppSecret" no="inputTaxAppSecret" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
          <el-form-item :label="'Token'" required>
            <el-input v-model="from.inputTaxToken" no="inputTaxToken" :disabled="!isEdit" style="width:300px;" />
          </el-form-item>
        </div>
      </el-row>
    </el-form>
  </div>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { stringToBool } from '@/utils/commonUtil'
import { queryInvoiceTitleByOfficeFunc } from '@/api/sysManage/officeInvoiceTitle'
import { OfficeInvoiceTitle } from '@/class/model/sys/OfficeInvoiceTitle'

export default {
  name: 'OfficeInputTaxConfig',
  props: {
    isEdit: { type: Boolean, required: true, default: false },
    officeId: { type: Number, required: true }
  },
  data() {
    return {
      loading: true,
      SystemConstants,
      from: new OfficeInvoiceTitle().fillDefaultValue().getData(),
      titleGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          onRowClicked: this.onRowClick
        },
        gridParams: {},
        gridApi: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: [],
        titleColumnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_ReceiptInvoiceTitle'),
            field: 'invoiceTitle',
            suppressMenu: true,
            width: 220
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxNumber'), field: 'taxAccount', suppressMenu: true,
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_IsDefaultTitle'), field: 'isDefault', suppressMenu: true,
            width: 120,
            valueFormatter: params => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ReceiptInvoiceChannel'), field: 'inputTaxInvoiceChannel', suppressMenu: true,
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.columnLabelFunc(SystemConstants.INVOICE_CHANNEL_STATUS, params.value)
            }
          }
        ]
      }
    }
  },
  computed: {
    isNuoNuo() { // 诺诺全电
      return this.from.inputTaxInvoiceChannel === 1
    },
    isBwjsy() { // 百旺金穗云
      return this.from.inputTaxInvoiceChannel === 2
    }
  },
  watch: {
    isEdit: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    },
    officeId: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    }
  },
  async created() {
    this.init()
  },
  methods: {
    invoiceChannelChange() {
      this.from.inputTaxAppKey = ''
      this.from.inputTaxAppSecret = ''
      this.from.inputTaxToken = ''
      this.from.invoiceIssuer = 0
    },
    init() {
      if (this.officeId) {
        queryInvoiceTitleByOfficeFunc({
          officeId: this.officeId
        }).then(res => {
          this.titleGrid.rowData = res.data
          if (this.titleGrid.rowData && this.titleGrid.rowData.length > 0) {
            this.from = this.titleGrid.rowData[0]
            this.titleGrid.gridApi.clearFocusedCell()
          }
        })
      }
    },
    async onRowClick(event) {
      if (!event || !event.data) return
      this.from = event.data
    }
  }
}
</script>
